import "../../scss/pages/mobile-applications.scss";

document.addEventListener("DOMContentLoaded", function () {
	const buttonAppStoreList = document.querySelectorAll('.mobileApplications-page .btn-app');
	
	buttonAppStoreList.forEach((buttonAppStore) => {
		buttonAppStore.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'mobileAppPage', buttonAppStore.dataset.tag]);
			/* eslint-enable */
		})
	});
});